import React from 'react'
import FilterPanel from '../components/FilterPanel';
import { FaUserCircle } from "react-icons/fa";

const MostWinningUserList = () => {
    return (
        <div className='p-2'>
            <div className='flex justify-between border-b border-b-gray-300 pb-2'>
                <h6 className="font-semibold">Top 5 Most Winning Users</h6>
                <FilterPanel />
            </div>
            <div className='flex flex-col text-sm text-[#000] p-2'>
                <div className='flex justify-between mb-2 bg-slate-50 p-2 rounded-md'>
                    <div className='flex items-center gap-3'>
                        <FaUserCircle size={22} color='#424f60'/>
                        <span>TestMAU (Aung Paing - 50%)</span>
                    </div>
                    <span className="font-semibold">+7800000 Ks</span>
                </div>
                <div className='flex justify-between mb-2 bg-slate-50 p-2 rounded-md'>
                    <div className='flex items-center gap-3'>
                    <FaUserCircle size={22} color='#424f60'/>
                        <span>apstheaee (YZET)</span>
                    </div>
                    <span className="font-semibold">+7800000 Ks</span>
                </div>
                <div className='flex justify-between mb-2 bg-slate-50 p-2 rounded-md'>
                    <div className='flex items-center gap-3'>
                    <FaUserCircle size={22} color='#424f60'/>
                        <span>89iueressd (TH)</span>
                    </div>
                    <span className="font-semibold">+7800000 Ks</span>
                </div>
                <div className='flex justify-between mb-2 bg-slate-50 p-2 rounded-md'>
                    <div className='flex items-center gap-3'>
                       <FaUserCircle size={22} color='#424f60'/>
                        <span>huger64gdgd (Tun Tun)</span>
                    </div>
                    <span className="font-semibold">+7800000 Ks</span>
                </div>
                <div className='flex justify-between mb-2 bg-slate-50 p-2 rounded-md'>
                    <div className='flex items-center gap-3'>
                       <FaUserCircle size={22} color='#424f60'/>
                        <span>567jurt454 (Mg Mg OPO)</span>
                    </div>
                    <span className="font-semibold">+7800000 Ks</span>
                </div>
            </div>
        </div>
    )
}

export default MostWinningUserList;